export function saveLoginMissLocation(location: string) {
  if (location === '/logout') {
    localStorage.removeItem('TD-loginMissRedirect')
  } else {
    localStorage.setItem('TD-loginMissRedirect', location)
  }
}
